/** Blank structured document template for the user-facing Document Editor. */
const defaultDocumentContent = {
  meta: {
    title: 'Untitled Document',
    subtitle: '',
    version: '1.0',
    lastUpdated: new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
  },
  chapters: [
    {
      id: 'ch1',
      title: 'Chapter 1',
      sections: [
        {
          id: 'ch1-s1',
          title: 'Introduction',
          type: 'body',
          body: 'Start writing your content here. Use chapters and sections to organize your document.',
        },
      ],
    },
  ],
};

export default defaultDocumentContent;